<!--Temporary hide for now - https://app.clickup.com/t/8692pd8d4-->
<!--<div class="title">{{ 'classrooms.invite.title' | translate }}</div>

<div class="email-wrapper" [class.sent]="emailSent">

  <app-form-field class="email-field" [control]="emailsControl">
    <on-ui-input class="email-control"
                 [formControl]="emailsControl"
                 [placeholder]="'classrooms.invite.emails-placeholder' | translate">
    </on-ui-input>
  </app-form-field>
  <on-ui-button class="email-button primary"
                [disabled]="true"
                [state]="emailButtonState"
                (click)="inviteViaEmail()"
                label="classrooms.invite.invite">
  </on-ui-button>

  <div class="email-sent-message">
    {{ 'classrooms.invite.invitation-sent' | translate }}
   </div>
</div>-->

<div class="link-wrapper">
  <!--Temporary hide for now - https://app.clickup.com/t/8692pd8d4-->
  <!--  <div class="link"> {{ 'classrooms.invite.get-link' | translate }}
    <a href="{{meetingUrl}}" target="_blank" rel="noopener noreferrer"> {{ meetingUrl }}</a>
  </div>-->
  <div class="copy-button" [class.copied]="copied" #shareLinkRef>
    <span
      data-test="copy-link"
      [ngxClipboard]
      [cbContent]="meetingUrl"
      (cbOnSuccess)="onCopied($event)"
      [container]="shareLinkRef">
      <span class="copy-button-message">
        {{ 'classrooms.invite.copied' | translate }}
      </span>

      <span class="copy-button-link">
        {{ 'classrooms.invite.copy-link' | translate }}
        <app-icon icon="copy-link" width="12" height="12"></app-icon>
      </span>
    </span>
  </div>
</div>
